import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';

import IssuesBreakdown from './IssuesBreakdown';
import Loading from '../../../../components/Loading';
import NoElements from '../../../../components/states/NoElements';

const queryRelationshipsByType = gql`
  query Relationships($typeId: String, $projectId: String) {
    relationshipsByType(typeId: $typeId, projectId: $projectId) {
      id
      consumerElement {
        id
        name
        props
      }
      producerElement {
        id
        name
      }
      consumer
      producer
      created_at
      project_id
      props
      type_id
    }
  }
`;

const ELEMENT_RELATIONSHIPS_CHANGED_SUBSCRIPTION = gql`
  subscription onProjectElementRelationshipsChanged($projectId: ID!) {
    projectElementRelationshipsChanged(projectId: $projectId) {
      consumer
      created_at
      custom_props
      datasource_id
      deleted_at
      icon_id
      id
      producer
      project_id
      props
      restored_at
      strength
      type_id
      updated_at
    }
  }
`;

const withData = compose(
  graphql(queryRelationshipsByType, {
    name: 'relationshipsByType',
    options: ({ companyRelationshipTypeId, projectId }) => ({
      variables: {
        typeId: companyRelationshipTypeId,
        projectId: projectId,
      },
      fetchPolicy: 'network-only',
    }),
    props: props => {
      return {
        subscribeToRelationshipsChange: currentProps => {
          return props.relationshipsByType.subscribeToMore({
            document: ELEMENT_RELATIONSHIPS_CHANGED_SUBSCRIPTION,
            variables: {
              projectId: currentProps.projectId,
            },
            updateQuery: (prev, { subscriptionData }) => {
              console.log('subscription data: ', subscriptionData);
              return prev;
              // if (
              //   !subscriptionData.data ||
              //   !subscriptionData.data.elementChanged
              // ) {
              //   return prev;
              // }

              // const changedElement = subscriptionData.data.elementChanged;

              // return {
              //   ...prev,
              //   elementsByNameOrId: prev.elementsByNameOrId.map(ele => {
              //     if (ele.id === changedElement.id) {
              //       return changedElement;
              //     }
              //     return ele;
              //   }),
              //};
            },
          });
        },
        //     subscribeToNewElements: currentProps => {
        //       return props.elementsByNameOrId.subscribeToMore({
        //         document: ELEMENT_CREATED_SUBSCRIPTION,
        //         variables: {
        //           typeId: currentProps.issueTypeId,
        //           projectId: currentProps.currentProjectId,
        //         },
        //         updateQuery: (prev, { subscriptionData }) => {
        //           if (
        //             !subscriptionData.data ||
        //             !subscriptionData.data.newElementsCreated ||
        //             !subscriptionData.data.newElementsCreated.length
        //           ) {
        //             return prev;
        //           }

        //           const newElements = subscriptionData.data.newElementsCreated;
        //           return {
        //             ...prev,
        //             elementsByNameOrId: prev.elementsByNameOrId.concat(newElements),
        //           };
        //         },
        //       });
        //     },
        //     subscribeToElementDelete: currentProps => {
        //       return props.elementsByNameOrId.subscribeToMore({
        //         document: ELEMENT_DELETED_SUBSCRIPTION,
        //         variables: {
        //           typeId: currentProps.issueTypeId,
        //           projectId: currentProps.currentProjectId,
        //         },
        //         updateQuery: (prev, { subscriptionData }) => {
        //           if (
        //             !subscriptionData.data ||
        //             !subscriptionData.data.deleteElement
        //           ) {
        //             return prev;
        //           }

        //           const deletedElement = subscriptionData.data.deleteElement;

        //           return {
        //             ...prev,
        //             elementsByNameOrId: prev.elementsByNameOrId.filter(el => el.id !== deletedElement.id),
        //           };
        //         },
        //       });
        //     },
        ...props,
      };
    },
  }),
);

@connect()
@withData
class IssuesBreakdownContainer extends Component {
  subscription = {
    subscribeToNewElements: null,
    subscribeToRelationshipsChange: null,
    subscribeToElementDelete: null,
  };

  componentWillMount() {
    const {
      subscribeToRelationshipsChange,
      subscribeToElementDelete,
      subscribeToNewElements,
    } = this.props;
    this.subscription.subscribeToRelationshipsChange = subscribeToRelationshipsChange(
      this.props,
    );
    // this.subscription.subscribeToElementDelete = subscribeToElementDelete(
    //   this.props,
    // );
    // this.subscription.subscribeToNewElements = subscribeToNewElements(
    //   this.props,
    // );
  }

  componentWillUnmount() {
    // this.subscription.subscribeToNewElements();
    // this.subscription.subscribeToElementDelete();
    this.subscription.subscribeToRelationshipsChange();
  }

  render() {
    const {
      relationshipsByType: { relationshipsByType },
      setCurrentElement,
    } = this.props;

    if (!relationshipsByType)
      return <Loading loadingMessage="Your data is being loaded..." />;

    if (!relationshipsByType.length)
      return (
        <div
          style={{
            border: '1px solid rgba(0,0,0,0.125)',
          }}
        >
          <NoElements
            missingEntity={'issues linked to companies'}
            missingType={'issues'}
            dashboard
          />
        </div>
      );

    const groupedRels = relationshipsByType.reduce((p, c) => {
      const company = c.producerElement.name;
      const issue = c.consumerElement.name;
      const issueStatus = c.consumerElement.props.Status;
      const companyElement = c.producerElement;

      if (!p[company]) {
        p[company] = {
          Total: 1,
          companyElement: companyElement,
        };
      } else {
        p[company].Total = p[company].Total + 1;
      }

      if (!p[company][issueStatus]) {
        p[company][issueStatus] = 1;
      } else {
        p[company][issueStatus] = p[company][issueStatus] + 1;
      }

      return p;
    }, {});

    const data = Object.keys(groupedRels).map(company => {
      return {
        id: company,
        companyElement: groupedRels[company].companyElement,
        label: company,
        value: groupedRels[company],
        color: '#ddd',
      };
    });

    return (
      <div
        style={{
          flex: 1,
          flexDirection: 'column',
          display: 'flex',
          padding: 20,
        }}
      >
        <label className="dashboard-panel-header">Issues Breakdown</label>
        <IssuesBreakdown
          setCurrentElement={setCurrentElement}
          relationships={relationshipsByType}
          data={data}
        />
      </div>
    );
  }
}

export default IssuesBreakdownContainer;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/IssuesBreakdown/IssuesBreakdownContainer.js